﻿import { request_trip } from "./request_trip";
import { booking_information } from "../../Booking/Booking_Information";

export class request {
    public booking_information: booking_information = new booking_information();
    public trips: request_trip[] = [];
}